import { ReactComponent as GraphArrowIncrease } from "assets/svg/graph-arrow-increase.svg";
import { ReactComponent as GraphArrowDecrease } from "assets/svg/graph-arrow-decrease.svg";

import { ReportEdgeItem, ReportItemType } from "types/Reports";
import { REPORT_SENSOR_REGISTRY } from "constant/report";
import { getHighestOrLowestDayDisplay } from "./utils/reportString";
import { formatValueAndUnitBasedOnTypeInReport } from "./utils/reportFormat";

type ReportItemEdgeTextProps = {
    isHighest: boolean;
    dateFormat: string;
    item: ReportEdgeItem;
    itemType: ReportItemType;
};

export default function ReportItemEdgeText({
    isHighest,
    dateFormat,
    item,
    itemType,
}: Readonly<ReportItemEdgeTextProps>) {
    const edgeText = isHighest ? 'highest' : 'lowest';
    const wasOnText = 'was on';

    const subject = `The ${edgeText} ${REPORT_SENSOR_REGISTRY[itemType].edgeSubject} ${wasOnText}`;
    const unit = REPORT_SENSOR_REGISTRY[itemType].unit;
    const valueDisplay = formatValueAndUnitBasedOnTypeInReport(itemType, item.value, unit, true);
    let withText = ', with ';

    if (itemType === 'waterLeakage') {
        withText = ` with a count of `;
    }

    // The pattern is The {highest/lowest} {type} was on {date}, {with / with a count of} {value} {unit}
    return <section className="report-edge-text mt-2">
        { isHighest ? <GraphArrowIncrease width="16px" height="16px" /> : <GraphArrowDecrease width="16px" height="16px" />}
        <p>
            {subject}
            <span className="report-edge-text-hl">{` ${getHighestOrLowestDayDisplay(item.dates, dateFormat)}`}</span>
            {withText}
            <span className="report-edge-text-hl">{`${valueDisplay}.*`}</span>
        </p>
    </section>;
}
